import React from "react";
import SubmissionResult from "./SubmissionResult";

export function DisplayValidationErrors({
  validationErrors,
}: SubmissionResult) {
  const entries = Object.entries(validationErrors ?? {});

  return (
    entries.length > 0 && (
      <ul>
        {entries.map((entry) => (
          <li key={`field-error-${entry[0]}`}>{entry[1]}</li>
        ))}
      </ul>
    )
  );
}

export function DisplaySubmissionError(
  responseData: SubmissionResult | "GeneralFailure",
  generalError?: string | undefined,
  response?: Response | undefined,
) {
  if (responseData === "GeneralFailure") {
    return (
      <>
        {generalError ??
          "There was an issue submitting your request. Please try again later."}
        {response?.status && ` (${response.status})`}
      </>
    );
  }

  return (
    <>
      {responseData.message}
      {response?.status && ` (${response.status})`}
      {DisplayValidationErrors(responseData)}
    </>
  );
}
